import api from './api';

// Service Types
export const getServiceTypes = async (params = {}) => {
  const res = await api.get('/admin/fulfillment/service-types/', { params });
  return res.data;
};

export const getServiceType = async (sid) => {
  const res = await api.get(`/admin/fulfillment/service-types/${sid}/`);
  return res.data;
};

export const createServiceType = async (data) => {
  const res = await api.post('/admin/fulfillment/service-types/', data);
  return res.data;
};

export const updateServiceType = async (sid, data) => {
  const res = await api.put(`/admin/fulfillment/service-types/${sid}/`, data);
  return res.data;
};

export const deleteServiceType = async (sid) => {
  const res = await api.delete(`/admin/fulfillment/service-types/${sid}/`);
  return res.data;
};

export const toggleServiceType = async (sid) => {
  const res = await api.post(`/admin/fulfillment/service-types/${sid}/toggle/`);
  return res.data;
};

// Service Type Pricing
export const getServiceTypePricing = async (params = {}) => {
  const res = await api.get('/admin/fulfillment/service-type-pricing/', { params });
  return res.data;
};

export const getServiceTypePricingByServiceType = async (serviceTypeSid) => {
  const res = await api.get(`/admin/fulfillment/service-type-pricing/by-service-type/${serviceTypeSid}/`);
  return res.data;
};

export const createServiceTypePricing = async (data) => {
  const res = await api.post('/admin/fulfillment/service-type-pricing/', data);
  return res.data;
};

export const updateServiceTypePricing = async (sid, data) => {
  const res = await api.put(`/admin/fulfillment/service-type-pricing/${sid}/`, data);
  return res.data;
};

export const deleteServiceTypePricing = async (sid) => {
  const res = await api.delete(`/admin/fulfillment/service-type-pricing/${sid}/`);
  return res.data;
};

// Add-On Services
export const getAddOnServices = async (params = {}) => {
  const res = await api.get('/admin/fulfillment/addon-services/', { params });
  return res.data;
};

export const getAddOnService = async (sid) => {
  const res = await api.get(`/admin/fulfillment/addon-services/${sid}/`);
  return res.data;
};

export const createAddOnService = async (data) => {
  const res = await api.post('/admin/fulfillment/addon-services/', data);
  return res.data;
};

export const updateAddOnService = async (sid, data) => {
  const res = await api.put(`/admin/fulfillment/addon-services/${sid}/`, data);
  return res.data;
};

export const deleteAddOnService = async (sid) => {
  const res = await api.delete(`/admin/fulfillment/addon-services/${sid}/`);
  return res.data;
};

// Storage Pricing
export const getStoragePricing = async (params = {}) => {
  const res = await api.get('/admin/fulfillment/storage-pricing/', { params });
  return res.data;
};

export const getStoragePricingByServiceType = async (serviceTypeSid) => {
  const res = await api.get(`/admin/fulfillment/storage-pricing/?service_type_sid=${serviceTypeSid}`);
  return res.data;
};

export const createStoragePricing = async (data) => {
  const res = await api.post('/admin/fulfillment/storage-pricing/', data);
  return res.data;
};

export const updateStoragePricing = async (sid, data) => {
  const res = await api.put(`/admin/fulfillment/storage-pricing/${sid}/`, data);
  return res.data;
};

export const deleteStoragePricing = async (sid) => {
  const res = await api.delete(`/admin/fulfillment/storage-pricing/${sid}/`);
  return res.data;
};

// Fulfillment Requests
export const getFulfillmentRequests = async (params = {}) => {
  const res = await api.get('/admin/fulfillment/requests/', { params });
  return res.data;
};

export const getFulfillmentRequest = async (sid) => {
  const res = await api.get(`/admin/fulfillment/requests/${sid}/`);
  return res.data;
};

export const updateFulfillmentRequest = async (sid, data) => {
  const res = await api.patch(`/admin/fulfillment/requests/${sid}/`, data);
  return res.data;
};

export const updateFulfillmentRequestItem = async (requestSid, itemSid, data) => {
  const res = await api.patch(`/admin/fulfillment/requests/${requestSid}/items/${itemSid}/`, data);
  return res.data;
};

export const recalculateFees = async (sid) => {
  const res = await api.post(`/admin/fulfillment/requests/${sid}/recalculate-fees/`);
  return res.data;
};

export const uploadInspectionImage = async (sid, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(`/admin/fulfillment/requests/${sid}/upload-inspection-image/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const uploadPackageImage = async (sid, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(`/admin/fulfillment/requests/${sid}/upload-package-image/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const uploadFulfillmentRequestItemReceivedImage = async (requestSid, itemSid, file, confirmedItemsCount) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('confirmed_items_count', String(confirmedItemsCount));
  const res = await api.post(`/admin/fulfillment/requests/${requestSid}/items/${itemSid}/upload-received-image/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

// Pricing Preview
export const previewPricing = async (data) => {
  const res = await api.post('/admin/fulfillment/preview-pricing/', data);
  return res.data;
};

// Warehouse Receiver Address
export const getWarehouseAddresses = async (params = {}) => {
  const res = await api.get('/admin/fulfillment/warehouse-addresses/', { params });
  return res.data;
};

export const getWarehouseAddress = async (sid) => {
  const res = await api.get(`/admin/fulfillment/warehouse-addresses/${sid}/`);
  return res.data;
};

export const createWarehouseAddress = async (data) => {
  const res = await api.post('/admin/fulfillment/warehouse-addresses/', data);
  return res.data;
};

export const updateWarehouseAddress = async (sid, data) => {
  const res = await api.put(`/admin/fulfillment/warehouse-addresses/${sid}/`, data);
  return res.data;
};

export const deleteWarehouseAddress = async (sid) => {
  const res = await api.delete(`/admin/fulfillment/warehouse-addresses/${sid}/`);
  return res.data;
};

export const setActiveWarehouseAddress = async (sid) => {
  const res = await api.post(`/admin/fulfillment/warehouse-addresses/${sid}/set-active/`);
  return res.data;
};

